module.exports = __webpack_public_path__ + "static/img/avatar-08.16e7823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-08.jpg
// module id = pL0F
// module chunks = 22